export const SELF_RETURN_CARRIER = {
	id: 'SELF_RETURN',
	name: { def: 'Customer self return' },
};
